export default __webpack_public_path__ + "static/webRotator/svg/becb63c32cb0c1a31302778a0f6960e7.svg";